import config from '../../config';

export default class WhatsNewService {
  constructor(Authentication, Utils, $http, $sce, $timeout) {
    'ngInject';

    Object.assign(this, { Authentication, Utils, $http, $sce, $timeout });
    this.init();
  }

  async init() {
    this.refreshing = false;
    this.markAsReadAfterRefresh = false;
    this.isNewUnreadItem = false;
    this.sideBarOpen = false;
    this._onSidebarStateChangeHandlers = [];
    this.data = [];
    await this.Authentication.userLoaded;

    if (!this.Authentication.user.isManager) {
      return;
    }

    this.refresh();
  }

  isNotRead() {
    if (!this.data.length) {
      return false;
    }

    const whatsNewReadItems =
      this.Authentication.user.settings.clientFlags?.whatsNewReadItems.split(',') || [];

    return this.data.some((item) => !whatsNewReadItems.includes(String(item.id)));
  }

  openSidebar() {
    this.sideBarOpen = true;
    this._onSidebarStateChangeHandlers.forEach((h) => h(true));
  }

  closeSidebar() {
    this.sideBarOpen = false;

    if (this.isNotRead()) {
      this.markAllAsRead();
    }

    this._onSidebarStateChangeHandlers.forEach((h) => h(false));
  }

  markAllAsRead() {
    this.Authentication.user.settings.clientFlags.whatsNewReadItems = this.data
      .map((item) => item.id)
      .join(',');
    this.Authentication.syncSettings();
    this.isNewUnreadItem = false;
  }

  refreshAndMarkAsRead() {
    if (config.SKIP_MARK_AS_READ) {
      return;
    }

    if (this.data.length) {
      this.markAllAsRead();
      return;
    }

    this.markAsReadAfterRefresh = true;
    if (!this.refreshing) {
      this.refresh();
    }
  }

  onSidebarStateChange(handler) {
    this._onSidebarStateChangeHandlers.push(handler);
    return () => {
      this._onSidebarStateChangeHandlers = this._onSidebarStateChangeHandlers.filter(
        (h) => h !== handler
      );
    };
  }

  async refresh() {
    if (!config.WHATS_NEW_URL) {
      return;
    }

    try {
      this.getData();
    } catch (e) {
      console.warn(e);
    }

    this.$timeout.cancel(this._timer);
    this._timer = this.$timeout(config.WHATS_NEW_INTERVAL);
    await this._timer;
    this.refresh();
  }

  async getData() {
    const response = await this.$http.get(config.WHATS_NEW_URL, {
      params: {
        per_page: 100,
      },
      ignoreLoadingBar: true,
      ignoreGlobalErrorHandler: true,
    });

    this.data = response.data;
    this.data.forEach((item) => {
      item.contentHTML = item.content.rendered;
      item.titleHTML = item.title.rendered;
      item.date = this.Utils.getRealDate(item.date);
    });

    if (this.markAsReadAfterRefresh) {
      this.markAllAsRead();
      this.markAsReadAfterRefresh = false;
      return;
    }

    if (this.isNotRead()) {
      this.isNewUnreadItem = true;
    }
  }
}
